/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var BookNotepadIcon24Solid = forwardRef('BookNotepadIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M5.25 2.402A4 4 0 0 0 3 6v12a4 4 0 0 0 2.25 3.598V2.402Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.75 21.992c.083.005.166.008.25.008h9a4 4 0 0 0 4-4V6a4 4 0 0 0-4-4H7a4.06 4.06 0 0 0-.25.008v19.984ZM9.5 6.75a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1-.75-.75ZM10.25 9a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5h-6Zm-.75 3.75a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1-.75-.75Z" })));
});
